// extracted by mini-css-extract-plugin
export default {"page":"styles_page__QAF0q","subtitle":"styles_subtitle__eaRsK","title":"styles_title__Hm+xe"};